import { Grid, Tooltip, Typography } from '@alice-financial/pretext-ui'
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite'
import * as React from 'react'
import { Link } from 'react-router-dom'
import { HealthcheckRowData } from '../types'

interface HealthcheckTaskCellProps {
  row: HealthcheckRowData
}

export const HealthcheckTaskCell = ({ row }: HealthcheckTaskCellProps) => {
  return (
    <Grid
      component={row.navigationPath ? Link : 'div'}
      to={row.navigationPath ? row.navigationPath : undefined}
      height="100%"
      container
      justifyContent="space-between"
      spacing={1}
      alignItems="center"
      flexWrap="nowrap"
      sx={{ cursor: row.navigationPath ? 'pointer' : 'default', textDecoration: 'none', pr: 2 }}
    >
      <Grid>
        <Typography variant="body2" fontWeight="bold">
          {row.primary}
        </Typography>
        {row.secondary && (
          <Typography variant="caption" color="text.secondary" display="block" sx={{ textWrap: 'pretty' }}>
            {row.secondary}
          </Typography>
        )}
      </Grid>

      {row.specialAction || (
        <Grid container alignItems="center">
          <Tooltip title={row.navigationPath ? 'Start' : ''} arrow placement="left">
            <PlayCircleFilledWhiteIcon
              color={row.status === 'disabled' || !row.navigationPath ? 'disabled' : 'primary'}
              sx={{ display: 'flex', alignSelf: 'center' }}
            />
          </Tooltip>
        </Grid>
      )}
    </Grid>
  )
}
